import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProductShowcase, { ShowcaseProduct } from './ProductShowcase';
import InsuranceNeedsWizard from './InsuranceNeedsWizard';

const LifeCISection: React.FC = () => {
  const { t } = useTranslation();

  const products: ShowcaseProduct[] = [
    {
      id: 'l1',
      company: 'Life Co',
      name: t('insurance.product1.name'),
      description: t('insurance.product1.description'),
      features: [
        t('insurance.product1.feature1'),
        t('insurance.product1.feature2'),
        t('insurance.product1.feature3'),
      ],
      imageUrl: '/path-to-image1.jpg',
      price: '$29.99',
      tag: 'Most Popular',
    },
  ];

  return (
    <Box>
      <ProductShowcase
        title={t('insurance.title')}
        products={products}
        learnMoreLabel={t('insurance.learnMore')}
      />
      <InsuranceNeedsWizard />
    </Box>
  );
};

export default LifeCISection;